module.exports = __webpack_public_path__ + "static/media/feature-milk.b0ad0808.jpg";